<div class="search">
  <span class="fa fa-search"></span>
  <input id="{{id}}" type="text" [value]="searchText" (input)="searchText=$event.target.value" (keyup)=onKeyUp($event) placeholder="{{placeholder}}">
</div>
